enum Action {
  FETCH_SUMMARY_DATA = 'fetchSummaryData',
}

export default Action;
